<template>
  <div id="app">
    <!-- 导航栏 -->
    <NavBar :currentSection="currentSection" @navigate="handleNavigation" @download="handleDownload" />
    
    <!-- 下载区域 -->
    <HeroSection v-if="currentSection === 'home'" @download="handleDownload" />
    
    <!-- 更新日志区域 -->
    <ChangelogSection v-if="currentSection === 'changelog'" @download="handleDownload" />
    
    <!-- 盒子特色区域 -->
    <FeaturesSection v-if="currentSection === 'home'"/>
    
    <!-- 页脚 -->
    <FooterSection />
    
    <!-- 左下角固定二维码组件 (仅PC端显示) -->
    <QrCodeWidget ref="qrCode" />
    
    <!-- PC端右侧底部弹框广告 -->
    <PopupAd ref="popupAd" @download="handleDownload" />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import ChangelogSection from './components/ChangelogSection.vue'
import HeroSection from './components/HeroSection.vue'
import FeaturesSection from './components/FeaturesSection.vue'
import FooterSection from './components/FooterSection.vue'
import QrCodeWidget from './components/QrCodeWidget.vue'
import PopupAd from './components/PopupAd.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    ChangelogSection,
    HeroSection,
    FeaturesSection,
    FooterSection,
    QrCodeWidget,
    PopupAd
  },
  data() {
    return {
      currentSection: 'home'
    }
  },
  methods: {
    handleNavigation(section) {
      this.currentSection = section
      console.log('当前导航到:', section);
      
    },
    
    handleDownload() {
      // 检测设备类型并执行相应的下载逻辑
      const userAgent = navigator.userAgent.toLowerCase()
      
      if (/android/.test(userAgent)) {
        // Android设备
        window.open('https://example.com/download/android', '_blank')
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        // iOS设备
        window.open('https://example.com/download/ios', '_blank')
      } else {
        // PC端，显示二维码
        if (this.$refs.qrCode) {
          this.$refs.qrCode.show()
        }
      }
    },
    
    // 动态rem适配
    setRem() {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const designWidth = 375;
      const baseRem = 10;
      let currentRem = (screenWidth / designWidth) * baseRem;
      const minRem = 16;
      const maxRem = 20;

      if (currentRem < minRem) {
        currentRem = minRem;
      } else if (currentRem > maxRem) {
        currentRem = maxRem;
      }

      document.documentElement.style.fontSize = currentRem + 'px';
    }
  },
  mounted() {
    // 设置rem适配
    this.setRem();
    window.addEventListener('resize', this.setRem);
    window.addEventListener('orientationchange', () => {
      setTimeout(this.setRem, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRem);
    window.removeEventListener('orientationchange', this.setRem);
  }
}
</script>

<style lang="scss">

</style>